import React, { useState } from "react";
import { signup, isAuthenticated } from "../auth";
import { Link, Redirect } from "react-router-dom";
import signupsvg from "../../assets/undraw_choosing_house_v37h.svg";

const Signup = () => {
  const [values, setValues] = useState({
    name: "",
    email: "",
    password: "",
    error: "",
    success: false,
  });
  const { name, email, password, success, error } = values;

  const handleChange = (name) => (event) => {
    setValues({ ...values, error: false, [name]: event.target.value });
  };

  const clickSubmit = (e) => {
    e.preventDefault();
    setValues({ ...values, error: false });
    signup({ name, email, password }).then((data) => {
      if (data.error) {
        setValues({ ...values, error: data.error, success: false });
      } else {
        setValues({
          ...values,
          name: "",
          email: "",
          password: "",
          error: "",
          success: true,
        });
      }
    });
  };

  const showError = () => {
    return (
      <div
        className="alert alert-danger"
        style={{ display: error ? "" : "none" }}
      >
        {error}
      </div>
    );
  };

  const showSuccess = () => {
    return (
      <div
        className="alert alert-info"
        style={{ display: success ? "" : "none" }}
      >
        <h6>
          New account is created.Please <Link to="/signin">Signin</Link>{" "}
        </h6>
      </div>
    );
  };

  const redirectUser = () => {
    if (isAuthenticated()) {
      return <Redirect to="/" />;
    }
  };

  return (
    <div className="container-fluid mt-5 ">
      <div className="row">
        <div className="col-sm-6 ">
          <img src={signupsvg} alt="" />
        </div>
        <div className="col-sm-4 mt-5">
          <h2 className="text-muted mb-3">Sign up</h2>
          {showSuccess()}
          {showError()}
          <form className="mb-3">
            <div className="mb-3">
              <input
                onChange={handleChange("name")}
                type="text"
                className="form-control"
                placeholder=" Name"
                value={name}
              />
            </div>
            <div className="mb-3">
              <input
                onChange={handleChange("email")}
                type="email"
                className="form-control"
                placeholder=" Email address"
                value={email}
              />
            </div>
            <div className="mb-3">
              <input
                onChange={handleChange("password")}
                type="password"
                className="form-control"
                placeholder=" Password"
                value={password}
              />
            </div>

            <button
              onClick={clickSubmit}
              type="submit"
              className="btn btn-success btn-lg btn-block"
            >
              Sign up
            </button>
          </form>

          <Link className="text-muted " to="/signin">
            <i className="fas fa-arrow-left" style={{ fontSize: "20px" }}></i>
          </Link>
        </div>
        {redirectUser()}
      </div>
    </div>
  );
};

export default Signup;
